var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"subscription-badge",class:[`subscription-badge--${_vm.tone}`, { 'subscription-badge--outline': _vm.outline }]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }